var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ag-card-container',{attrs:{"title":"Export","fluid":"","no-content-padding":""}},[_c('v-container',{staticClass:"py-0"},[_c('filter-selection',{on:{"validate":_vm.fetchData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }